import { createFileRoute } from '@tanstack/react-router'
import { PlusIcon } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { OrganizationDepartment, useDepartments } from '@/api/hooks/useDepartments'
import { AdminOnlyRoute } from '@/components/admin-only-route'
import { StateSwitcher } from '@/components/atoms/state-switcher'
import PageLayout from '@/components/layout/page-layout'
import DepartmentsTable from '@/components/organisms/departments-table'
import { CreateUpdateDepartmentDialog } from '@/components/organisms/departments-table/create-update-department-dialog'
import { Button } from '@/components/ui/button'

export const Route = createFileRoute('/_authenticated/departments')({
  component: () => (
    <AdminOnlyRoute>
      <DepartmentsPage />
    </AdminOnlyRoute>
  ),
})

function DepartmentsPage() {
  const { t } = useTranslation()
  const { data: departments = [], isError, isLoading } = useDepartments()
  const [dialogOpen, setDialogOpen] = useState(false)
  const [editing, setEditing] = useState<OrganizationDepartment | undefined>()

  const openCreate = () => {
    setEditing(undefined)
    setDialogOpen(true)
  }

  const openEdit = (department: OrganizationDepartment) => {
    setEditing(department)
    setDialogOpen(true)
  }

  return (
    <PageLayout title={t('navigation.departments')}>
      <div className="flex flex-col gap-4">
        <div className="flex justify-end">
          <Button onClick={openCreate}>
            <PlusIcon />
            {t('departmentsTable.createButton')}
          </Button>
        </div>
        <StateSwitcher isError={isError} isLoading={isLoading}>
          <DepartmentsTable departments={departments} onEditDepartment={openEdit} />
        </StateSwitcher>
      </div>
      <CreateUpdateDepartmentDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        department={editing}
      />
    </PageLayout>
  )
}
